import { render } from "./InventoryOrders.vue?vue&type=template&id=26de1d3c&scoped=true"
import script from "./InventoryOrders.vue?vue&type=script&lang=js"
export * from "./InventoryOrders.vue?vue&type=script&lang=js"

import "./InventoryOrders.vue?vue&type=style&index=0&id=26de1d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26de1d3c"]])

export default __exports__